import styled from "styled-components";
import { COLORS } from "./constants";

export const ClientsContainer = styled.div`
  flex: 1;
  width: 100%;
  box-shadow: 0px 1px 18px 0 ${COLORS.GUNMETAL_20};
`;
